import { RELATIONSHIP } from "../../../constants/relationship";
import { Member } from "../../../types/employee.types";
import { EnrollmentSchema } from "../../../types/enrollment.types";
import { CoverageType } from "../../../types/plan.types";
import calculateAge from "../age";

export const getCoveredDependents = (coverage: CoverageType): string[] => {
	const coveredDependents: string[] = [];
	if (coverage.ES?.active === true) {
		coveredDependents.push(RELATIONSHIP.spouse);
	}
	if (coverage.EC?.active === true) {
		coveredDependents.push(RELATIONSHIP.child);
		coveredDependents.push(RELATIONSHIP.stepchild);
		coveredDependents.push(RELATIONSHIP.court_ordered_dependent);
	}
	return coveredDependents;
};

type GroupEligibleDependents = {
	eligibleDependents: Member[];
	ineligibleRelationshipDependents: Member[];
	ineligibleDependents: Member[];
};

export const fullDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

export const getHealthPlanEligibleDependents = (
	dependents: Member[],
	coverage: CoverageType
): GroupEligibleDependents => {
	const coveredDependents = getCoveredDependents(coverage);
	// console.log("Covered Depednets", coveredDependents);

	const eligibleDependents: Member[] = [];
	const ineligibleDependents: Member[] = [];
	const ineligibleRelationshipDependents: Member[] = [];
	dependents.forEach((dependent: Member) => {
		// console.log("eligiblityDialogProps======> 222", dependent);
		const { relationship, date_of_birth, is_disabled, dependent_type } = dependent;
		// const otherDate = new Date("2023-05-01");
		const age = calculateAge(date_of_birth, fullDate);
		// console.log("Age", age);
		if (
			dependent_type !== "Not Eligible" &&
			((relationship !== "SPOUSE" &&
				coveredDependents.includes(relationship as string) &&
				(age < 26 || (age >= 26 && is_disabled === true))) ||
				relationship === "SPOUSE")
		) {
			eligibleDependents.push(dependent);
		} else {
			if (coveredDependents.includes(relationship as string)) {
				ineligibleDependents.push(dependent);
			} else {
				// debugger;
				ineligibleRelationshipDependents.push(dependent);
			}
		}
	});

	return {
		eligibleDependents,
		ineligibleDependents,
		ineligibleRelationshipDependents
	};
};
//  modify it leter
const normalizeRelationship = (relationship: string) => {
	const relation = relationship.trim().toLowerCase().replace(/-/g, " ");

	if (relation === "step child") return "child";
	if (relation === "court ordered dependent") return "child";
	if (relation === "legal custody child") return "child";
	// if (relation === "grandchild") return "child";

	return relation;
};

const resolveCoverageCode = (coverageCode: string, coverage: CoverageType): string | null => {
	// exact coverage active
	if ((coverage as any)?.[coverageCode]?.active) {
		return coverageCode;
	}

	if (coverageCode === "EC" && (coverage as any)?.ECH?.active) {
		return "ECH";
	}

	if ((coverage as any)?.ED?.active) {
		return "ED";
	}

	return null;
};
export const getEligibleDependents = (
	dependents: Member[],
	coverage: CoverageType,
	dependent_eligibility: any = []
): GroupEligibleDependents => {
	// const coveredDependents = getCoveredDependents(coverage);
	// console.log("Covered Depednets", coveredDependents);

	// console.log(dependent_eligibility, "dependent_eligibility");
	// console.log("eligiblityDialogProps======>", dependents, coverage, dependent_eligibility);

	const eligibleDependents: Member[] = [];
	const ineligibleDependents: Member[] = [];
	const ineligibleRelationshipDependents: Member[] = [];
	const coverageCodeForRelationship: any = {
		spouse: "ES",
		child: "EC",
		children: "ECH",
		dependent: "ED"
	};
	let dependentEligibilityRelationshipTypeFound: any = null;
	// let dependentEligible = false;
	dependents.forEach((dependent: Member) => {
		const { relationship, date_of_birth, is_disabled, dependent_type } = dependent;
		// const otherDate = new Date("2023-05-01");

		if (
			relationship?.trim().toLowerCase().replace(/-/g, " ") === "grand child" ||
			relationship?.trim().toLowerCase() === "grandchild"
		) {
			ineligibleDependents.push(dependent);
			return;
		}

		const age = calculateAge(date_of_birth, fullDate);
		// console.log(dependent, "Age", age);
		// console.log("eligiblityDialogProps======> 222", relationship, date_of_birth, is_disabled, dependent_type);
		// console.log("debug=====> 3333", relationship, date_of_birth, is_disabled, dependent_type);
		if (relationship) {
			// const relation=relationship.toLowerCase().includes("children")
			// let covergageCode: any = coverageCodeForRelationship[relationship.toLowerCase()];
			const normalizedRelationship = normalizeRelationship(relationship);

			const covergageCode: any = coverageCodeForRelationship[normalizedRelationship];
			// console.log("debug=====> 4444", covergageCode, normalizedRelationship);

			// dependentEligibilityRelationshipTypeFound =
			// 	dependent_eligibility.find(
			// 		(eligible_dependent: any) => eligible_dependent.relationship_type.toLowerCase() == "dependent"
			// 	) || null;
			// console.log("debug=====> 6666", dependentEligibilityRelationshipTypeFound);
			// if (!dependentEligibilityRelationshipTypeFound) {
			// dependentEligibilityRelationshipTypeFound = dependent_eligibility.find(
			// 	(eligible_dependent: any) =>
			// 		eligible_dependent.relationship_type.toLowerCase() == relationship.toLowerCase()
			// );
			dependentEligibilityRelationshipTypeFound = dependent_eligibility.find(
				(eligible_dependent: any) =>
					eligible_dependent.relationship_type.toLowerCase() === normalizedRelationship
			);

			if (!dependentEligibilityRelationshipTypeFound && coverage?.ED?.active) {
				dependentEligibilityRelationshipTypeFound =
					dependent_eligibility.find((item: any) => item.relationship_type.toLowerCase() === "dependent") ||
					null;
			}
			// } else { 464-65-3747
			// 	covergageCode = "ED";
			// }

			const resolvedCoverageCode = resolveCoverageCode(covergageCode, coverage);

			if (dependentEligibilityRelationshipTypeFound && resolvedCoverageCode) {
				const isClinicCardDependent =
					dependentEligibilityRelationshipTypeFound.relationship_type &&
					(normalizedRelationship?.trim().toLowerCase().includes("child") ||
						normalizedRelationship === "court-ordered dependent");

				const maxAge = isClinicCardDependent ? 26 : dependentEligibilityRelationshipTypeFound.max_age;
				if (
					(dependentEligibilityRelationshipTypeFound.min_age <= age &&
						// dependentEligibilityRelationshipTypeFound.max_age > age &&
						maxAge > age &&
						dependent_type != "Not Eligible") ||
					(is_disabled == true && dependent_type != "Not Eligible")
				) {
					eligibleDependents.push(dependent);
				} else {
					ineligibleDependents.push(dependent);
				}
			} else {
				ineligibleRelationshipDependents.push(dependent);
			}
		}
	});
	return {
		eligibleDependents,
		ineligibleDependents,
		ineligibleRelationshipDependents
	};

	// return dependentEligible
	// 	? {
	// 			eligibleDependents,
	// 			ineligibleDependents,
	// 			ineligibleRelationshipDependents
	// 	  }
	// 	: {
	// 			eligibleDependents: [],
	// 			ineligibleDependents: [],
	// 			ineligibleRelationshipDependents: []
	// 	  };
};

export const getEnrollmentsByCoverage = (
	enrollments: EnrollmentSchema[]
): {
	coveredSpouseEnrollment: EnrollmentSchema | null;
	employeeEnrollment: EnrollmentSchema | null;
	coveredChildrenEnrollments: EnrollmentSchema[];
} => {
	let employeeEnrollment: EnrollmentSchema | null = null;
	let coveredSpouseEnrollment: EnrollmentSchema | null = null;
	const coveredChildrenEnrollments: EnrollmentSchema[] = [];
	enrollments.forEach((enrollment: EnrollmentSchema) => {
		const { member } = enrollment;
		if (member?.relationship === RELATIONSHIP.spouse) {
			coveredSpouseEnrollment = enrollment;
		} else if (enrollment.member_SSN === enrollment.insured_SSN) {
			employeeEnrollment = enrollment;
		} else {
			coveredChildrenEnrollments.push(enrollment);
		}
	});
	return {
		coveredChildrenEnrollments,
		coveredSpouseEnrollment,
		employeeEnrollment
	};
};
export const getClinicCardEligibleDependents = (dependents: Member[], coverage: CoverageType): Member[] => {
	const coveredDependents = [
		RELATIONSHIP.child,
		RELATIONSHIP.spouse,
		RELATIONSHIP.stepchild,
		RELATIONSHIP.court_ordered_dependent
	];

	const eligibleDependents: Member[] = [];
	dependents.forEach((dependent: Member) => {
		const { relationship, date_of_birth, is_disabled, dependent_type } = dependent;
		const age = calculateAge(date_of_birth, fullDate);
		if (
			dependent_type !== "Not Eligible" &&
			((relationship !== "SPOUSE" &&
				coveredDependents.includes(relationship as string) &&
				((age < 26 && age >= 8) || (age >= 26 && is_disabled === true))) ||
				relationship === "SPOUSE")
		) {
			eligibleDependents.push(dependent);
		}
	});

	return eligibleDependents;
};
